import React from "react";
import "./Footer.css";
import Piano from "./PianoThings/PianoThings";
import {InlineOutlinedLogoWhite, LogoInline} from "../../assets/images";
import MagneticCircleButton from "../Buttons/MagneticCircleButton/MagneticCircleButton";
import {Link} from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-wrapper">
          <div className="footer-details">
            <div className="footer-logo">
              <Link to="/">
                <img src={LogoInline} alt={LogoInline} />
              </Link>
            </div>
            <p className="paragraph-details">Software Engineer at Procol</p>
            <p className="paragraph-details">
              Open for <br />
              side-projects & collaborations
            </p>
          </div>
          <div className="working-content">
            <h1>Interested in Work Together</h1>
          </div>
          <div className="footer-details">
            <p className="paragraph-details">
              I'm a passionate engineer who thrives at the intersection of
              design, problem-solving, and code. I love crafting software that’s
              not only visually compelling but also intuitive to use and
              thoughtfully engineered beneath the surface.
            </p>
          </div>
        </div>

        <div className="footer-widget-border">
          <MagneticCircleButton text="Let's" text2="Connect" to="/contact-us" />
        </div>
        <div className="secondary-footer-wrapper">
          <div className="secondary-large-text">
            <span data-text="1">Damn</span>
            <span data-text="2">it</span>
            <span data-text="symbol">,</span>
            <span data-text="3">Deep</span>
            <span data-text="symbol">!!</span>
          </div>
        </div>
        <div className="bottom-footer-wrapper">
          <p>{new Date().getFullYear()} &copy; Deep Kapadia</p>
          <div className="footer-logo">
            <img src={InlineOutlinedLogoWhite} alt={InlineOutlinedLogoWhite} />
          </div>
          <Piano />
        </div>
      </div>
      <svg aria-hidden="true" className="svg-grid-bottom">
        <defs>
          <pattern
            id="hero"
            width="80"
            height="80"
            x="50%"
            y="-1"
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none"></path>
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth="0"
          fill="url(#hero)"
          className="my-rect"
        ></rect>
      </svg>
    </footer>
  );
};

export default Footer;
